
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fileRunRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileRunRequest"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientCustomerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"claimUploadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importClaimsId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repriceDateId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genericIndicatorId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4DateTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repriceName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isProcessed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEmptyRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rateSummaryTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthsOfData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"x4ClientName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4CarrierName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4AccountName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4GroupName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4FinalClaimStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4StartDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4EndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4CoveredEmployees"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"x4CoveredMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importClaims"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"repriceDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"genericIndicator"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"rateSummaryType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"x4DateType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"clientCustomer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"claim"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceRunId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceRun"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repriceName"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":710}};
    doc.loc.source = {"body":"fragment fileRunRequest on FileRunRequest {\n  id\n  userId\n  clientCustomerId\n  claimUploadId\n  importClaimsId\n  repriceDateId\n  genericIndicatorId\n  x4DateTypeId\n  repriceName\n  isProcessed\n  isEmptyRequest\n  createdAt\n  rateSummaryTypeId\n  monthsOfData\n  user {\n    id\n    fullName\n  }\n  x4ClientName\n  x4CarrierName\n  x4AccountName\n  x4GroupName\n  x4FinalClaimStatus\n  x4StartDate\n  x4EndDate\n  x4CoveredEmployees\n  x4CoveredMembers\n  importClaims {\n    value\n  }\n  repriceDate {\n    value\n  }\n  genericIndicator {\n    value\n  }\n  rateSummaryType {\n    value\n  }\n  x4DateType {\n    value\n  }\n  clientCustomer {\n    name\n  }\n  claim {\n    fileName\n  }\n  sourceRunId\n  sourceRun {\n    id\n    repriceName\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["fileRunRequest"] = oneQuery(doc, "fileRunRequest");
        
